module.exports = __webpack_public_path__ + "static/media/Screenshot at Jan 14 19-19-25_1579007616707.0bfa110d.png";